<template>
    <section class="container-fluid mt-2">
        <div class="row mt-2">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                    <div class="mr-auto">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb clearfix pt-3">
                                <li class="breadcrumb-item active" style="cursor: pointer;" @click="backDespacho()">{{Proyecto==null ? 'Despacho' : 'Proyecto'}}</li>
                                <li class="breadcrumb-item active">Calendario</li>
                            </ol>
                        </nav>
                    </div>
                </nav>
            </div>
        </div>
		<div class="row mt-2">
			<div class="col-12 col-sm-12 col-md-12 col-lg-12">
				<div class="card">
					<div class="card-body p-2">
						<div class="row mb-2 mt-2">
							<div class="col-lg-12">
								<form class="form-inline">
									<div class="form-group mr-2">
										<label for="" class="mr-2">Personal</label>
										<select style="width: 150px;" @change="get_listcalendar()" v-model="Filtros.IdTrabajador" class="form-control">
											<option value="">Todos</option>
											<option v-for="(item,index) in ListaTrabajadores" :value="item.IdTrabajador" :key="index">{{item.Nombre}}</option>
										</select>
									</div>
									<div class="form-group mr-2">
										<label for="" class="mr-2">Vehículo</label>
										<select style="width: 150px;" @change="get_listcalendar()" v-model="Filtros.IdVehiculo" class="form-control">
											<option value="">Todos</option>
											<option v-for="(item,index) in ListaVehiculos" :value="item.IdVehiculo" :key="index">{{item.Vehiculo+' '+item.Numero}}</option>
										</select>
									</div>
									<div class="form-group mr-2">
										<label for="" class="mr-2">Tipo Servicio</label>
										<select style="width: 150px;" @change="get_listcalendar();ListaServ()" v-model="Filtros.IdConfigS" class="form-control">
											<option value="">Todos</option>
											<option value="1">Mantenimiento</option>
											<option value="2">Servicio</option>
											<option value="3">Proyecto</option>
											<option value="4">Tiempo no Productivo</option>
											<option value="5">Garantía</option>
										</select>
									</div>
									<div class="form-group mr-2">
										<label for="" class="mr-1">SubTipo Servicio</label>
										<select style="width: 150px;" @change="get_listcalendar()" v-model="Filtros.Tipo_Serv"  class="form-control">
                    					    <option :value="''" >Todos</option>
                    					    <option v-for="(item, index) in ListaTipoServicio" :key="index" :value="item.IdTipoSer" >{{item.Concepto}}</option>
                    					</select>
									</div>
									<div class="form-group mr-2">
										<label>Clientes</label>
									</div>
									<div class="form-group mr-2" style="max-width: 13rem">
										<treeselect
											@input="get_listcalendar(null);GetListaSucursales();"
											:disabled="Proyecto!=null"
											:options="ListaClientes"
											placeholder="Busque un Cliente..."
											v-model="Filtros.IdCliente"
											:disable-fuzzy-matching="true"
										/>
									</div>
									<div class="form-group mr-2">
										<label>Propiedades</label>
									</div>
									<div class="form-group mr-2" style="max-width: 13rem">
										<treeselect
											@input="get_listcalendar(null);GetListaNumContratos();"
											:disabled="Proyecto!=null"
											:options="ListaSucursales"
											placeholder="Busque una Propiedad..."
											v-model="Filtros.IdClienteS"
											:disable-fuzzy-matching="true"
										/>
									</div>
									<div class="form-group mr-2">
										<label>Contrato</label>
									</div>
									<div class="form-group mr-2" style="max-width: 13rem">
										<treeselect
											@input="get_listcalendar(null)"
											:disabled="Proyecto!=null"
											:options="ListaContratos"
											placeholder="Busque un Contrato..."
											v-model="Filtros.IdContrato"
											:disable-fuzzy-matching="true"
										/>
									</div>
								</form>
							</div>
						</div>
						<!-- <div class="row">
							<div class="col-lg-12">
								<form class="form-inline">
								
								</form>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
        <div class="row mb-3 mt-2">
            <div class="col-12 col-sm-12 col-md-10 col-lg-9 col-xl-9">
                <div class="card card-calendar">
                    <div class="card-body">
                        <CLoader :pConfigLoad="ConfigLoad">
                            <template slot="BodyFormLoad">
                                <FullCalendar
                                    :options="calendarOptions"
                                    class="full-calendar"
                                    ref="fullCalendar"
                                />
                            </template>
                        </CLoader>

                        <Modal :Showbutton="false" :size="size" :Nombre="NameList">
                            <template slot="Form">
                                <FormServicio :pOrigen="'CALENDARIO'"></FormServicio>
                            </template>
                        </Modal>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-md-2 col-lg-3 col-xl-3">
                <div class="card card-scroll">
                    <div class="card-body" >
                        <CLoader :pConfigLoad="ConfigLoadDetalle">
                            <template slot="BodyFormLoad">
                                <h5  class="card-title">{{(FechaActual)}} </h5>
                                <button @click="iradespacho" type="button" title="ver despacho" class="btn-fil-002 mt-4">
                                    <i class="fas fa-shipping-fast"></i>
                                </button>
                                <table class="table table-striped table-hover align_middle">
                                    <thead>
                                        <tr>
                                            <th>SERVICIOS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in ServiciosDia" :key="index">
                                            <td @click="Editar(item.id)" :style=" 'border-left: 5px solid ' + item.color + '; ' " >
						        				<b>Folio: </b>{{item.Folio}}<br>
                                                <b>Cliente: </b>{{item.Cliente}}<br>
												<b>Propiedad: </b>{{item.Propiedad}}<br>
						        				<b>Hora Inicio: </b>{{$getCleanHours(item.HoraI)}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                        </CLoader>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from "@fullcalendar/core/locales/es";
import FormServicio from "../servicios/Form.vue";
import Modal from "@/components/Cmodal.vue";

export default {
	props:['pOrigen','pProyecto'],
	name:'CalendarioDespacho',
    components: {
        FullCalendar, // make the <FullCalendar> tag available
		FormServicio,
        Modal
    },
    data: function () {
        return {
            calendarPlugins: [
                // plugins must be defined in the JS
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin, // needed for dateClick
            ],
            calendarWeekends: true,
            calendarEvents: [
                // initial event data
            ],
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            ConfigLoadDetalle:{
                ShowLoader:true,
                ClassLoad:true
            },
			Filtros:{
				IdTrabajador:'',
				IdVehiculo:'',
				IdConfigS:'',
				Tipo_Serv:'',
				IdCliente:null,
				IdClienteS:null,
				IdContrato:null,
				Fecha_I:'',
				Fecha_F:''
			},
            locale: esLocale,
            EsModal: true, //indica si es modal o no
            size: "modal-xl",
            NameList: "Servicios",
            ServiciosDia:[],
            FechaActual:'',
            FechaActual2:'',
            calendarOptions:{
				locale:esLocale,
				contentHeight:650,
				// ref:"fullCalendar",
				initialView:'dayGridMonth',
				headerToolbar:{
					start: 'prev,next,today',
					center: 'title',
					end: 'dayGridMonth,timeGridWeek,timeGridDay'
				},
				plugins:[dayGridPlugin,timeGridPlugin,interactionPlugin],
				weekends:true,
				events:[],
				dayMaxEvents:4,
				dateClick:this.handleDateClick,
				eventClick:this.eventClick,
                eventDisplay:'block',
				datesSet:this.get_listcalendar
				// class:'full-calendar'
			},
			ListaTrabajadores:[],
			ListaVehiculos:[],
			ListaTipoServicio:[],
			ListaClientes:[],
			ListaSucursales:[],
			ListaContratos:[],
			Proyecto:null
        };
    },
    methods: {
		async GetTrabajador(){
			await this.$http.get('trabajador/get',{
				params:{
					Rol:'USUARIO APP',
					IdPerfil:4
				}
			}).then((res)=>{
				this.ListaTrabajadores=res.data.data.trabajador;
			})
		},
		async GetVehiculo(){
			await this.$http.get('vehiculo/get',{
				params:{
					RegEstatus:'A'
				}
			}).then((res)=>{
				this.ListaVehiculos=res.data.data.vehiculo;
			})
		},
		async ListaServ()
        {
			this.ListaTipoServicio=[];
			this.Filtros.Tipo_Serv='';
            await this.$http.get(
            'tiposervicio/get',
            {
                params:{
                    Nombre:'',
                    Entrada:50,
                    pag:0,
                    RegEstatus:'A',
					IdConfigS:this.Filtros.IdConfigS
                }
            }
            ).then( (res) => {
                this.ListaTipoServicio =res.data.data.tiposervicio;
            });
        },
		GetListaClientes(){
			this.$http.get("clientes/get"
			).then((res)=>{
				this.ListaClientes=res.data.data.clientes.map(function(obj){
					return {id:obj.IdCliente,label:obj.Nombre}
				})
				if (this.Proyecto!=null) {
					this.GetListaSucursales();
				}
			});
		},
		GetListaSucursales(){
			if (this.Proyecto==null) {
				this.Filtros.IdClienteS=null;
				this.Filtros.IdContrato=null;
			}
			// this.Filtros.IdClienteS=null;
			// this.Filtros.IdContrato=null;
			this.ListaSucursales=[];
			this.ListaContratos=[];
			this.$http.get("clientesucursal/get",{
				params:{
					Todos:true,
					RegEstatus:'A',
					IdCliente:this.Filtros.IdCliente
				}
			}
			).then((res)=>{
				this.ListaSucursales=res.data.data.sucursal.map(function(obj){
					return {id:obj.IdClienteS,label:obj.Nombre}
				});
				if (this.Proyecto!=null) {
					this.GetListaNumContratos();
				}
			});
		},
		GetListaNumContratos(){
			if (this.Proyecto==null) {
				this.Filtros.IdContrato=null;
			}
			this.$http.get("numcontrato/get",{
				params:{
					IdClienteS:this.Filtros.IdClienteS
				}
			}).then((res)=>{
				this.ListaContratos=res.data.data.contractlist.map(function(obj){
					return {id:obj.IdContrato,label:obj.NumeroC}
				})
			})
		},

       async get_listcalendar(info=null) {
		// console.log('contador');
		if (info!=null) {
			this.Filtros.Fecha_I=info.startStr;
			this.Filtros.Fecha_F=info.endStr;
		}
        this.ConfigLoad.ShowLoader=true;

        await this.$http.get("servicio/calendar",{
			params:{
				IdTrabajador:this.Filtros.IdTrabajador,
				IdVehiculo:this.Filtros.IdVehiculo,
				IdConfigS:this.Filtros.IdConfigS,
				Tipo_Serv:this.Filtros.Tipo_Serv,
				IdCliente:this.Filtros.IdCliente,
				IdClienteS:this.Filtros.IdClienteS,
				IdContrato:this.Filtros.IdContrato,
				Fecha_I:this.Filtros.Fecha_I,
				Fecha_F:this.Filtros.Fecha_F
			}
		}).then((res) => {
                // this.calendarOptions.events = [];
				this.$refs.fullCalendar.getApi().removeAllEvents();
				let DataCalendar=[];
                const actividades = res.data.data.calendar;

                actividades.forEach((item, index) => {
                    DataCalendar.push({
                        start: `${item.start}`,
                        title: "Folio: " + item.Folio + " \n",
                        allDay: false,
                        id: item.id,
                        backgroundColor: item.color,
                        color: item.color,
                        //eventTextColor: item.ColorLetra,
                        textColor: item.ColorLetra,
                        //borderColor:item.ColorLetra,
                        Servicio: item.Folio + "\n" + " Cliente: " + item.title,
                        Hora: item.HoraI.substring(0, 5),
                        Fecha: this.formatoFecha(item.FechaInicio),
                    });
                });
				this.$refs.fullCalendar.getApi().addEventSource(DataCalendar);
                this.ConfigLoad.ShowLoader=false;
            });
        },
        async get_eventsday(FechaBusqueda) {
            this.ConfigLoadDetalle.ShowLoader=true;
            await this.$http.get("servicio/calendarday",
                {
                params: {
                FechaBusqueda: FechaBusqueda,
                },
            })
            .then((res) => {
                this.ServiciosDia = res.data.data.calendar;
                this.FechaActual =  this.formatoFecha(res.data.data.Fecha);
                this.FechaActual2 =  res.data.data.Fecha;
                this.ConfigLoadDetalle.ShowLoader=false;
            });
        },

        formatoFecha(texto) {

			let data = texto;

			let dias = [
				"Lunes",
				"Martes",
				"Miercoles",
				"Jueves",
				"Viernes",
				"Sabado",
				"Domingo"
			];
			let meses = [
				"Enero",
				"Febrero",
				"Marzo",
				"Abril",
				"Mayo",
				"Junio",
				"Julio",
				"Agosto",
				"Septiembre",
				"Octubre",
				"Noviembre",
				"Diciembre"
			];

			let date = new Date(data);
			//let fechaNum = date.getDate() + 1;
			//let fechaNum = date.getDate();
			let fechaultimo=new Date(date.getFullYear(),date.getMonth()+1,0);
			var fechaNum;
			var mes_name;
			if (date.toDateString()==fechaultimo.toDateString()){
				fechaNum = 1;
				// Si estamos en diciembre:
				// console.log(date.getMonth()+1);
				if (date.getMonth()+1==12) {
					mes_name=0;
				}
				else{
					mes_name = date.getMonth()+1;
				}
			}
			else{
				fechaNum = date.getDate() + 1;
				mes_name = date.getMonth();
			}

			return dias[date.getDay()] + " " + fechaNum + " de " + meses[mes_name] + " de " + date.getFullYear();
        },
        toggleWeekends() {
            this.calendarWeekends = !this.calendarWeekends; // update a property
        },
        gotoPast() {
            let calendarApi = this.$refs.fullCalendar.getApi(); // from the ref="..."
            calendarApi.gotoDate("2000-01-01"); // call a method on the Calendar object
        },
        handleDateClick(arg) {
        /* if (
            confirm(
            //"Desea ir al calendario de la fecha seleccionada " +
            "Desea ver los servicios del día " +
                arg.dateStr +
                " ?"
            )
        ) {
            let data = { Fecha: arg.dateStr };
            this.get_eventsday(arg.dateStr);
        }*/

            let data = { Fecha: arg.dateStr };
            this.get_eventsday(arg.dateStr);
        },
        eventClick: function (calEvent, jsEvent, view) {
            this.Editar(calEvent.event.id);
            //this.get_eventsday(calEvent.FechaInicio);
            //list_serviciofecha(calEvent.FechaInicio);

            // change the border color just for fun
            //$(this).css('border-color', callEvent.color);
        },
        Editar(Id) {
            this.bus.$emit("Nuevo", null, Id);
            $("#ModalForm").modal("show");


        },
		backDespacho() {
			if (this.Proyecto==null) {
				this.$router.push({ name: "despacho", params: {} });	
			}
			else{
				this.$router.push({name:'proyectodesglose',params:{IdProyecto:this.Proyecto.IdProyecto,IdContratoMaster:this.Proyecto.IdContratoMaster}});
			}
		},
        iradespacho()
        {
            let data = { Fecha: this.FechaActual2 };
            this.$router.push({ name: "despacho", params: { objeto: data } });
        },

        Timer(){
            this.IntervalTime = setInterval(
				function() {
					this.get_listcalendar(null);
				}.bind(this),10000
			);
        }
    },
    created() {
		this.bus.$off("ListCalendarioDespacho");
		this.GetTrabajador();
		this.GetVehiculo();
		if (this.pOrigen=='proyecto') {
			localStorage.setItem('proyecto',JSON.stringify(this.pProyecto));
		}
		if (this.pOrigen=='servicio'){
			if (localStorage.getItem('proyecto')) {
				localStorage.removeItem('proyecto');	
			}
		}
		if (localStorage.getItem('proyecto')!=undefined) {
			this.Proyecto=JSON.parse(localStorage.getItem('proyecto'));	
		}
		if (this.Proyecto!=null) {
			this.Filtros.IdCliente=this.Proyecto.IdCliente;
			this.Filtros.IdClienteS=this.Proyecto.IdClienteS;
			this.Filtros.IdContrato=this.Proyecto.IdContrato;
		}
        this.get_eventsday();
		this.GetListaClientes();
    },

    mounted(){
		// this.get_listcalendar();

		this.bus.$on("ListCalendarioDespacho", FechaBusqueda => {
			this.get_listcalendar();
		});

        // this.Timer();
    },


    destroy() {
        //this.Timer();

    }
};
</script>

<style lang='scss'>

.fc-more {
  font-size: 14px;
  font-weight: bold;
}
.fc-more-cell {
  text-align: center;
}
</style>
